export const hirePythonBannerContentAr = {
    mainHeading: "وظف مطوري Python",
    content:
        "مصدر موثوق لتوظيف مطوري Python المناسبين للشركات الناشئة والمؤسسات.",
    btnText: "استشر مطوري Python لدينا",
    bannerList: [
        { list: "مطورون مستقلون" },
        { list: "وظائف بدوام كامل" },
        { list: "فرق عمل عالمية" },
    ],
};

export const hirePythonExpertiseAr = {
    heading: "خبرات مطوري Python لدينا",
    discription:
        "يتخصص فريقنا من مطوري Python في إنشاء حلول قابلة للتوسع وآمنة وعالية الأداء. نستخدم قوة Python لبناء تطبيقات مبتكرة وتقديم تجارب تطوير سلسة للشركات من جميع الأحجام. سواء كان الأمر يتعلق بتطوير تطبيقات Python أو حلول مخصصة، فإن مطورينا جاهزون لتلبية احتياجاتك.",
    btnText: "حدد موعدًا لإجراء مكالمة اليوم",
    servicesData: [
        {
            title: "الاستشارات بلغة Python",
            description:
                "استفد من خبرة مطورينا في Python للحصول على رؤى استراتيجية ونصائح قيمة لمساعدتك في تحقيق أقصى استفادة من مشاريعك. نرشدك إلى أفضل الممارسات والأساليب المبتكرة لضمان نجاح المشروع.",
            icon: "/images/hire-page-icons/hire-python-icons8.svg",
        },
        {
            title: "تطوير الويب باستخدام Python",
            description:
                "مطورونا متمكنون في بناء تطبيقات ويب غنية بالميزات باستخدام Python. من المواقع البسيطة إلى المنصات المعقدة، نقدم حلولًا قابلة للتوسع تلبي احتياجات عملك وتوفر تجربة مستخدم رائعة.",
            icon: "/images/hire-page-icons/hire-python-icons1.svg",
        },
        {
            title: "تطوير واجهات برمجة التطبيقات (API) بـ Python",
            description:
                "لدينا خبرة واسعة في تطوير واجهات API قوية باستخدام Python، مما يتيح تكاملًا سلسًا وتواصلًا فعالًا بين التطبيقات المختلفة.",
            icon: "/images/hire-page-icons/hire-python-icons2.svg",
        },
        {
            title: "تطوير أنظمة CMS والبوابات الإلكترونية",
            description:
                "سواء كنت بحاجة إلى نظام إدارة محتوى (CMS) أو بوابة إلكترونية مخصصة، فإن مطورينا خبراء في استخدام Python لبناء منصات متقدمة وسهلة الاستخدام وآمنة.",
            icon: "/images/hire-page-icons/hire-python-icons4.svg",
        },
        {
            title: "الهجرة إلى Python",
            description:
                "إذا كنت ترغب في نقل أنظمتك الحالية إلى Python، فإن خبراءنا يمكنهم تنفيذ هذه العملية بسلاسة مع ضمان الحد الأدنى من الانقطاع في سير العمل.",
            icon: "/images/hire-page-icons/hire-python-icons5.svg",
        },
        {
            title: "الدمج مع الحلول الحالية",
            description:
                "نقدم خدمات دمج احترافية لتطبيقات Python مع مختلف المنصات والخدمات، سواء كان الأمر يتعلق بالأنظمة الخارجية أو الحلول القائمة، لزيادة الكفاءة والأداء.",
            icon: "/images/hire-page-icons/hire-python-icons6.svg",
        },
        {
            title: "حلول التجارة الإلكترونية باستخدام Python",
            description:
                "نحن متخصصون في بناء حلول تجارة إلكترونية قوية باستخدام Python لتحسين تجربة المستخدم وتعزيز التفاعل في الشراء عبر الإنترنت.",
            icon: "/images/hire-page-icons/hire-python-icons7.svg",
        },
        {
            title: "دعم وصيانة تطبيقات Python",
            description:
                "لا نقوم فقط ببناء تطبيقك باستخدام Python، بل نحرص أيضًا على استمرارية عمله بكفاءة من خلال خدمات الدعم والصيانة المستمرة.",
            icon: "/images/hire-page-icons/hire-python-icons8.svg",
        },
    ],
};

export const hirePythonPerformanceAr = {
    heading: "لماذا تختار بيتسكلان لتوظيف",
    greenHeading: "مطوري Python",
    subHeading:
        "في بيتسكلان، ندمج لغة Python مع أحدث تقنيات الواجهة الأمامية والموبايل لإنشاء تطبيقات قوية وقابلة للتوسع تلبي احتياجات عملك. سواء كنت بحاجة إلى منصة ويب أو حل مخصص للجوال، فإن منهجيتنا تضمن تطويرًا سلسًا، وأداءً ممتازًا، وتجربة مستخدم متكاملة. خدمات تطوير Python لدينا تضمن أن يعمل تطبيقك بكفاءة وينمو مع تطور أعمالك.",
    buttonText: "توظيف مطور اليوم",
    solutions: [
        {
            icon: "/images/hire-page-icons/chose-ror-section1.svg",
            title: "الوصول إلى مواهب معتمدة",
            description:
                "نقدّم لك مطوري Python تم التحقق من خبراتهم ومهاراتهم في التواصل باللغة الإنجليزية. نحن نضمن أن يكون المطورون الذين نوفرهم موهوبين وموثوقين.",
        },
        {
            icon: "/images/hire-page-icons/chose-ror-section2.svg",
            title: "اعثر على المطابقات في ثوانٍ",
            description:
                "ودّع البحث بين السير الذاتية الكثيرة. مع HireAI، يمكنك بسرعة استعراض أفضل مطوري Python والعثور على المطور المثالي لمشروعك.",
        },
        {
            icon: "/images/hire-page-icons/chose-ror-section3.svg",
            title: "وفّر من خلال التوظيف العالمي",
            description:
                "بفضل الوصول إلى شبكة تضم أكثر من 450,000 مطور من 190 دولة، يمكنك توفير ما يصل إلى 58٪ مقارنة بالتوظيف التقليدي.",
            noBorder: true,
        },
        {
            icon: "/images/hire-page-icons/chose-ror-section4.svg",
            title: "دعم بشري حقيقي",
            description:
                "اشعر بالثقة أثناء توظيف مطوري Python من خلال دعم فريقنا من خبراء التوظيف الذين سيرشدونك خلال العملية لضمان سلاسة التوظيف.",
        },
    ],
};

export const hirePythonCombinationsAr = {
    heading: "أفضل تركيبات Python لتطوير قوي وقابل للتوسع",
    description:
        "اكتشف الإمكانيات الكاملة لـ Python من خلال أفضل التركيبات التكنولوجية لبناء تطبيقات آمنة وقابلة للتوسع وعالية الأداء. وظّف مطوري Python الخبراء لتعزيز الابتكار وضمان تطوير سلس.",
    combinations: [
        {
            title: "Python + Django + PostgreSQL",
            description:
                "يضمن Django، وهو إطار عمل عالي المستوى بلغة Python، عند دمجه مع PostgreSQL، تطبيقات ويب آمنة وقابلة للتوسع وعالية الأداء.",
            icons: ["python.svg", "django.svg", "postgres.svg"],
        },
        {
            title: "Python + Flask + MySQL",
            description:
                "يساعد Flask، وهو إطار ويب خفيف بلغة Python، عند دمجه مع MySQL، على تطوير تطبيقات ويب قابلة للتوسع بسرعة وكفاءة.",
            icons: ["python.svg", "Flask.svg", "mysql-whale-icon.svg"],
        },
        {
            title: "Python + FastAPI + MongoDB",
            description:
                "يوفر FastAPI تطوير واجهات برمجة تطبيقات بسرعة باستخدام Python، بينما يعمل MongoDB كقاعدة بيانات NoSQL مرنة للتطبيقات الحديثة.",
            icons: ["python.svg", "fast-api.svg", "mongodb.svg"],
        },
        {
            title: "Python + React + PostgreSQL",
            description:
                "React لواجهة الاستخدام التفاعلية، وDjango أو Flask للمنطق الخلفي، وPostgreSQL كحل قوي لقاعدة البيانات العلائقية.",
            icons: ["python.svg", "react.svg", "postgres.svg"],
        },
        {
            title: "Python + TensorFlow + AWS",
            description:
                "استفد من Python مع TensorFlow لتطبيقات الذكاء الاصطناعي والتعلم الآلي، مدعومة بخدمات AWS السحابية لتوفير الحوسبة والتخزين القابل للتوسع.",
            icons: ["python.svg", "tensorflow.svg", "aws.svg"],
        },
        {
            title: "Python + FastAPI + GraphQL",
            description:
                "يُمكّن FastAPI كخلفية عالية الأداء مع GraphQL من تطوير واجهات برمجة تطبيقات فعالة واسترجاع بيانات مرن للتطبيقات الحديثة.",
            icons: ["python.svg", "fast-api.svg", "graphql.svg"],
        },
    ],
};

export const hirePythonStepsAr = {
    heading: "وظف مطوري Python في 4 خطوات سهلة",
    subHeading:
        "لم يكن توظيف أفضل مطوري Python أسهل من الآن. اتبع خطواتنا الأربع البسيطة للحصول على تجربة سلسة، وضمان المطابقة المثالية لمشروعك، والتسليم السريع، وتطوير عالي الجودة.",
    buttonText: "دعنا نجد المطور المثالي لك",
    steps: [
        {
            title: "اختر نموذج التوظيف المناسب",
            description:
                "اختر نموذج التوظيف الذي يناسب احتياجات مشروعك سواء كان بدوام كامل، جزئي، أو بالساعة. نحن نقدم الحل المخصص لمتطلباتك.",
            icon: "/images/hire-page-setps-icons/icon-1.svg",
        },
        {
            title: "فرز واختيار مطوري Python",
            description:
                "تصفح ملفات مطوري Python لدينا واختر الأنسب لمشروعك. نحن نضمن لك الوصول إلى أفضل المواهب المؤهلة.",
            icon: "/images/hire-page-setps-icons/icon-2.svg",
        },
        {
            title: "إجراء مقابلة فردية",
            description:
                "بعد اختيارك للمرشحين، يمكنك إجراء مقابلة فردية معهم لتقييم مهاراتهم النظرية والعملية والتأكد من ملاءمتهم لمشروعك.",
            icon: "/images/hire-page-setps-icons/icon-3.svg",
        },
        {
            title: "انضمام مطوري Python",
            description:
                "بمجرد اتخاذ القرار، سينضم مطور Python الذي تم اختياره إلى فريقك خلال 24 إلى 48 ساعة بعد التأكيد النهائي. ابدأ بثقة تامة.",
            icon: "/images/hire-page-setps-icons/icon-4.svg",
        },
    ],
};

export const coverTheStackPythonAr = {
    whereStart: "قاعدة البيانات", // You may change tab label rendering accordingly
    mainHeading: "وظّف مطوري Python خبراء لحلول قابلة للتوسع وعالية الأداء",
    subHeading:
        "في Bitsclan، نمكِّن رحلتك في تطوير الويب من خلال حزمة تقنيات Python قوية تضمن الكفاءة، والتوسع، والابتكار. يتخصص مطورونا ذوو الخبرة في بناء تطبيقات ويب آمنة، قائمة على البيانات، وعالية الأداء مخصصة لاحتياجات عملك.",
    tabs: [
        "قاعدة البيانات",
        "المكتبات",
        "الأطر",
        "ديف أوبس",
        "الاختبار",
    ],
    tabItems: [
        { tab: "الإطار", icon: "/images/tech-stack-icons/pytorch.svg", name: "PyTorch" },
        { tab: "الإطار", icon: "/images/tech-stack-icons/caffe.svg", name: "Caffe" },
        { tab: "الإطار", icon: "/images/tech-stack-icons/theano.svg", name: "Theano" },
        { tab: "الإطار", icon: "/images/tech-stack-icons/Flask.svg", name: "Flask" },
        { tab: "الإطار", icon: "/images/tech-stack-icons/bottle.svg", name: "Bottle" },
        { tab: "الإطار", icon: "/images/tech-stack-icons/cherrypy.svg", name: "CherryPy" },
        { tab: "الإطار", icon: "/images/tech-stack-icons/django.svg", name: "Django" },
        { tab: "الإطار", icon: "/images/tech-stack-icons/ember.svg", name: "FastAPI" },
        { tab: "الإطار", icon: "/images/tech-stack-icons/fast-api.svg", name: "FastAPI" },
        { tab: "الإطار", icon: "/images/tech-stack-icons/Pyramid.svg", name: "Pyramid" },
        { tab: "الإطار", icon: "/images/tech-stack-icons/tornado.svg", name: "Tornado" },
        { tab: "الإطار", icon: "/images/tech-stack-icons/py-qt.svg", name: "PyQt" },
        { tab: "الإطار", icon: "/images/tech-stack-icons/dash-framework.svg", name: "Dash Framework" },

        { tab: "قاعدة البيانات", icon: "/images/tech-stack-icons/postgres.svg", name: "PostgreSQL" },
        { tab: "قاعدة البيانات", icon: "/images/db3.png", name: "MongoDB" },
        { tab: "قاعدة البيانات", icon: "/images/db5.png", name: "MySQL" },
        { tab: "قاعدة البيانات", icon: "/images/tech-stack-icons/oracals.svg", name: "Oracle" },
        { tab: "قاعدة البيانات", icon: "/images/db7.png", name: "SQLite" },
        { tab: "قاعدة البيانات", icon: "/images/tech-stack-icons/redis.svg", name: "Redis" },
        { tab: "قاعدة البيانات", icon: "/images/tech-stack-icons/couchdb.svg", name: "Couch DB" },
        { tab: "قاعدة البيانات", icon: "/images/db8.png", name: "DynamoDB" },
        { tab: "قاعدة البيانات", icon: "/images/tech-stack-icons/neo4j.svg", name: "Neo4j" },
        { tab: "قاعدة البيانات", icon: "/images/tech-stack-icons/snowflake.svg", name: "SnowFlake" },

        { tab: "المكتبات", icon: "/images/tech-stack-icons/request.svg", name: "Requests" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/scrapy.svg", name: "Scrapy" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/pillow.svg", name: "Pillow" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/fabric.svg", name: "Fabric" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/scikit-learn.svg", name: "Scikit-learn" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/fast-api.svg", name: "FastAPI" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/numpy.svg", name: "NumPy" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/pandas.svg", name: "Pandas" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/matplotlib.svg", name: "Matplotlib" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/scipy.svg", name: "SciPy" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/tensorflow.svg", name: "TensorFlow" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/pytorch.svg", name: "PyTorch" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/keras.svg", name: "Keras" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/django.svg", name: "Django" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/Streamlit.svg", name: "Stream Lit" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/boto.svg", name: "Boto3" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/Flask.svg", name: "Flask" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/beautiful.svg", name: "Beautiful Soup" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/open-cv.svg", name: "OpenCV" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/seaborn.svg", name: "Seaborn" },

        { tab: "ديف أوبس", icon: "/images/tech-stack-icons/docker.svg", name: "Docker" },
        { tab: "ديف أوبس", icon: "/images/tech-stack-icons/azure.svg", name: "Azure" },
        { tab: "ديف أوبس", icon: "/images/tech-stack-icons/kubernetes.svg", name: "Kubernetes" },
        { tab: "ديف أوبس", icon: "/images/tech-stack-icons/google-cloud.svg", name: "Google Cloud" },
        { tab: "ديف أوبس", icon: "/images/tech-stack-icons/serverless-functions.svg", name: "Serverless Functions" },
        { tab: "ديف أوبس", icon: "/images/tech-stack-icons/aws.svg", name: "AWS" },
        { tab: "ديف أوبس", icon: "/images/tech-stack-icons/digital-ocean.svg", name: "Digital Ocean" },

        { tab: "الاختبار", icon: "/images/tech-stack-icons/postman.svg", name: "Postman" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/seaborn.svg", name: "Jmeter" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/selenium.svg", name: "Selenium" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/cypress.svg", name: "Cypress" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/browserstack.svg", name: "BrowserStack" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/bugzilla.svg", name: "Bugzilla" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/soap-icon.svg", name: "SoapUI" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/jasmine.svg", name: "Jasmine" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/karma.svg", name: "Karma" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/jenkins.svg", name: "Jenkins" },
    ]
};

export const hirePythonFactsDataAr = {
    heading: "حقائق سريعة عن",
    greenHeading: "فريق بايثون لدينا",
    buttonText: "حجز موعد",
    facts: [
        {
            text: "<strong>40+ مطوّر بايثون:</strong> يتكون فريقنا من أكثر من 40 مطورًا ماهرًا متخصصين في تطوير تطبيقات بايثون.",
        },
        {
            text: "<strong>25.98 سنة من الخبرة المشتركة:</strong> بمتوسط يقارب 26 عامًا من الخبرة، يتمتع فريقنا بفهم عميق لتطوير بايثون.",
        },
        {
            text: "<strong>خبرة في مجالات متنوعة:</strong> لدينا خبرة في حلول بايثون المخصصة، بما في ذلك تطوير الويب، وتطوير واجهات برمجة التطبيقات، وتكامل الأنظمة.",
        },
        {
            text: "<strong>مهارات متقدمة في السحابة وبدون خوادم:</strong> يتمتع مطورونا بمهارات قوية في بناء تطبيقات ويب آمنة باستخدام بايثون وفقًا لأفضل ممارسات الصناعة.",
        },
        {
            text: "<strong>خبرة في الحلول المعتمدة على البيانات:</strong> نعمل على البيانات الضخمة والتعلم الآلي والمزيد لإنشاء تطبيقات قوية تعتمد على بايثون.",
        },
    ]
};

export const factIdeaAr = {
    heading: "لست متأكدًا من فكرة تطبيقك؟ احصل على نموذج أولي خلال 6 إلى 8 أسابيع!",
    content:
        "هل لديك فكرة ولكنك غير متأكد من كيفية البدء؟ يمكن لخبرائنا في Golang مساعدتك في بناء نموذج أولي وظيفي خلال 6 إلى 8 أسابيع فقط! قم بالتحقق من رؤيتك، واختبر تفاعل المستخدمين، وأنشئ أساسًا قويًا للنجاح من خلال خدماتنا الاحترافية في التطوير.",
};

export const hirePythonPageContentAr = {
    hiringDetails: [
        {
            text: "التعاقد بالساعة",
            hours: "24 - 48",
            timeUnit: "ساعة",
            icon: "time.svg",
            bgColor: "#FDFDFF",
            durationLabel: "المدة",
            duration: "8 ساعات/يوم",
            minimumDaysLabel: "الحد الأدنى للأيام",
            minimumDays: "30 يومًا",
            billingLabel: "الفوترة",
            billing: "شهريًا",
            startWorkPhrase: "ابدأ العمل في غضون "
        },
        {
            text: "التعاقد بدوام كامل",
            hours: "48",
            timeUnit: "ساعة",
            icon: "full-time.svg",
            bgColor: "#FFFEFA",
            durationLabel: "المدة",
            duration: "8 ساعات/يوم",
            minimumDaysLabel: "الحد الأدنى للأيام",
            minimumDays: "30 يومًا",
            billingLabel: "الفوترة",
            billing: "شهريًا",
            startWorkPhrase: "ابدأ في غضون "
        },
        {
            text: "التعاقد بدوام جزئي",
            hours: "24 - 48",
            timeUnit: "ساعة",
            icon: "part-time.svg",
            bgColor: "#FDFFFA",
            durationLabel: "المدة",
            duration: "8 ساعات/يوم",
            minimumDaysLabel: "الحد الأدنى للأيام",
            minimumDays: "30 يومًا",
            billingLabel: "الفوترة",
            billing: "شهريًا",
            startWorkPhrase: "انطلق في غضون "
        },
    ],
    headingContent: [
        {
            "text": "نماذج التعاقد"
        },
        {
            "text": "المرنة لدينا"
        },
    ],
    discription: "اختر نموذج التعاقد الذي يناسب احتياجات مشروعك! سواء كنت بحاجة إلى مطورين بدوام كامل أو جزئي أو بالساعة، فإننا نقدم خيارات مرنة لضمان التعاون السلس وأقصى قدر من الكفاءة طوال مشروعك.",
    buttonText: "ابدأ الآن"
};

export const hirePythonFaqDataAr = {
    mainHeading: "الأسئلة الشائعة",
    subHeading:
        "اكتشف خدمات تطوير Python الخاصة بنا لحلول الويب المخصصة، وإنشاء واجهات برمجة التطبيقات، وإدارة النشر!",
    questionAnswer: [
        {
            id: "collapseOne",
            question: "ما هو تطوير Python؟",
            answer:
                "يشير تطوير Python إلى إنشاء التطبيقات والمواقع والبرمجيات باستخدام لغة البرمجة Python، وهي لغة مرنة وسهلة التعلم. تشتهر ببساطتها، مما يجعلها خيارًا شائعًا للمطورين لإنشاء تطبيقات الويب، وأتمتة المهام، والتعامل مع المشاريع المعتمدة على البيانات.",
        },
        {
            id: "collapseTwo",
            question: "لماذا يجب أن أوظف مطوري Python؟",
            answer:
                "توظيف مطوري Python يضمن حصولك على فريق من الخبراء يمكنه إنشاء تطبيقات قابلة للتوسع وآمنة وعالية الأداء بكفاءة. تُستخدم Python على نطاق واسع في تطوير الويب وتحليل البيانات والأتمتة، مما يجعلها مثالية لبناء حلول مخصصة تلبي احتياجاتك.",
        },
        {
            id: "collapseThree",
            question: "ما هي الخدمات التي يقدمها مطورو Python؟",
            answer:
                "يقدم مطورو Python مجموعة متنوعة من الخدمات مثل تطوير الويب، وإنشاء واجهات برمجة التطبيقات، وتطوير أنظمة إدارة المحتوى، وتحليلات البيانات، وتكامل الأنظمة. يمكنهم أيضًا مساعدتك في نقل الأنظمة الحالية إلى Python أو بناء تطبيقات جديدة من البداية.",
        },
        {
            id: "fourth",
            question: "كيف تضمنون جودة تطوير Python؟",
            answer:
                "يتبع مطورو Python لدينا أفضل الممارسات في الصناعة لتقديم تطوير ويب آمن باستخدام Python. يستخدمون أطر عمل حديثة، ويضمنون اختبارات شاملة، ويعملون في بيئة رشيقة لضمان أن يكون تطبيقك عالي الجودة، وقابل للتوسع، وسهل الاستخدام.",
        },
        {
            id: "fifth",
            question: "هل يمكنني توظيف مطوري Python لمشاريع قصيرة المدى؟",
            answer:
                "نعم، يمكنك توظيف مطوري Python على أساس قصير أو طويل المدى. سواء كنت بحاجة إلى مطور لبضعة أسابيع أو شهور، فإننا نقدم نماذج تعاون مرنة مثل التوظيف بدوام كامل أو جزئي أو حتى بالساعة لتناسب احتياجات مشروعك.",
        },
        {
            id: "sixth",
            question: "كم من الوقت يستغرق تطوير تطبيق Python؟",
            answer:
                "يعتمد الوقت المستغرق لتطوير تطبيق Python على مدى تعقيد المشروع. على سبيل المثال، قد يستغرق إنشاء موقع بسيط بضعة أسابيع، بينما قد يستغرق نظام أكثر تعقيدًا أو حل مخصص عدة أشهر. نحن نضمن التسليم في الوقت المناسب من خلال تخطيط وخبرة مهنية.",
        },
    ],
};

export const mainBannerImgPythonArabic = {
    backgroundImage: `url(/images/hire-page-images/hire-python.avif)`,
    factBackgroundImage: `url(/images/hire-page-images/hire-python-arabic.avif)`
};